import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getJobListing = async (token, type) => {
  try {
    const endpoint = type
      ? `/api/v1/admin/reports/lis_job_request?request_type=${type}`
      : `/api/v1/admin/reports/lis_job_request`;
    const response = await fetch(
      // eslint-disable-next-line no-undef
      `${BASE_URL}${endpoint}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    const data = await response.json();
    if (data?.status?.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
